import { useLocation } from "react-router-dom";
import HomePage from "@/components/home/HomePage";

export default function Index() {
  const { pathname } = useLocation();
  const language = pathname.startsWith("/en") ? "en" : pathname.startsWith("/ca") ? "ca" : "fr";
  return <HomePage key={language} language={language} />;
}
